import { Component, OnInit,DoCheck } from '@angular/core';
import {MessageService, ConfirmationService, SelectItem} from 'primeng/api';
import { Router, ActivatedRoute } from '@angular/router';

import { ControlService } from 'src/app/services/control/control.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { cancel,check } from 'src/app/config/img';
import { ImprimirMultipleService } from 'src/app/services/imprimirMultiples/imprimirMultipleService';
import { FirmaRevisionService } from 'src/app/services/firma_revision/firma-revision.service';



@Component({
  selector: 'app-control',
  templateUrl: './control.component.html',
  styleUrls: ['./control.component.css']
})
export class ControlComponent implements OnInit,DoCheck {
  public es:any;
  public date2:Date;
  public expression=false;
  public title="CONTROL DE CRISTALES, PLÁSTICOS, LUCES Y METALES";
  public control:any=[];
  public controlDataUpdate:any=[];
  public displayDialog=false;
  public editControl:any=[];
  public mostrar=false;
  public display: boolean = false;
  public createControlForm:FormGroup;
  public myMonth="";
  public cols:any=[];
  public database = "control";
  public databases = "plasticos";
  public selectedOpciones: string="";
  public oldValue: string="";
  public columnasVisibles: boolean=false;
  public opciones: SelectItem[];
  public cancel=cancel;
  public check=check;
  public selectedColumns:any[] ;
  public anchoTabla: string = "1500px";
  public showTables: boolean = true;
  public displayMultiple: boolean = false;
  public first = 0;
  public arrrayBooleanos = ['zona1','zona2','zona3','zona4','zona5','zona6','zona7','zona8','zona9'];
  public showDuplicate = true;


  constructor(
    private messageService:MessageService,
    private router:Router,
    private route:ActivatedRoute,
    private controlService:ControlService,
    private confirmationService: ConfirmationService,
    private FirmaRevisionService: FirmaRevisionService,
    private imprimirMultipleService:ImprimirMultipleService
    ) {
      this.iniciarUpdate();
      this.columnasSimples();
     
    }


  ngOnInit(): void {
    this.opciones=[
      {label:'no', value:'no'},
      {label:'si', value:'si'},
    ]
    this.es = {
      firstDayOfWeek: 1,
      dayNames: [ "domingo","lunes","martes","miércoles","jueves","viernes","sábado" ],
      dayNamesShort: [ "dom","lun","mar","mié","jue","vie","sáb" ],
      dayNamesMin: [ "D","L","M","X","J","V","S" ],
      monthNames: [ "enero","febrero","marzo","abril","mayo","junio","julio","agosto","septiembre","octubre","noviembre","diciembre" ],
      monthNamesShort: [ "ene","feb","mar","abr","may","jun","jul","ago","sep","oct","nov","dic" ],
      today: 'Hoy',
      clear: 'Borrar'
  }
  this.iniciar();
  this.iniciarUpdate();
}
listarCampos(){
 
  if(this.showTables){
    this.showTables=false;
      this.columnasTotales();
    
    
  }else{
    this.showTables=true;
    this.columnasSimples();
    
  }
}

columnasSimples(){
this.columnasVisibles=false;
this.anchoTabla="1500px";
this.cols = [
{ field: 'opciones', header: 'Opciones' },
{ field: 'fecha', header: 'Fecha' ,tipo: 'fecha'},
{ field: 'mes', header: 'Mes' },
{ field: 'revision', header: 'Revisión' },
{ field: 'revisado_nombre', header: 'Responsable registro' },
];

if ( localStorage.getItem('role').localeCompare('ROLE_ADMIN') != 0 ) {
  this.cols.splice(3,1);
}

this.selectedColumns = this.cols;
}
columnasTotales() {
  this.columnasVisibles=true;
  this.anchoTabla="4000px";
  this.cols = [
    { field: 'opciones', header: 'Opciones' },
    { field: 'fecha', header: 'Fecha' ,tipo: 'fecha'},
    { field: 'mes', header: 'Mes' },
    { field: 'revision', header: 'Revisión' },
    { field: 'zona1', header: 'Zona 1' },
    { field: 'zona2', header: 'Zona 2' },
    { field: 'zona3', header: 'Zona 3' },
    { field: 'zona4', header: 'Zona 4' },
    { field: 'zona5', header: 'Zona 5' },
    { field: 'zona6', header: 'Zona 6' },
    { field: 'zona7', header: 'Zona 7' },
    { field: 'zona8', header: 'Zona 8' },
    { field: 'zona9', header: 'Zona 9' },
    { field: 'revisado_nombre', header: 'Responsable registro' },
    { field: 'observaciones', header: 'Observaciones' }
   
  ];

  if ( localStorage.getItem('role').localeCompare('ROLE_ADMIN') != 0 ) {
    this.cols.splice(3,1);
  }
  this.selectedColumns=this.cols;
}
 iniciar() {
  this.mostrar = false;
  this.controlService.getListControl().subscribe((data:any)=>{
    //console.log(data.productos);
    this.control = data.productos;
    this.mostarTabla();
    /* this.recuperarPosicion(); */
  },error=>{
    console.log(error);
  });

 }
 mostarTabla(){
  this.mostrar=true;
 }
  showSuccess() {
    this.messageService.add({severity:'success', summary:'Service Message', detail:'Via MessageService'});
}


delete(id) {
    
    this.confirmationService.confirm({
      header:'Confirmación',
      acceptLabel:'Acceptar',
      rejectLabel:'Cancelar',
      message: 'Quieres eliminar este registro?',
      accept: () => {
        
        this.controlService.deleteControl(id).subscribe(data=>{
            console.log("Ha ido bien",data);
            this.iniciar();

        },error=>{
          console.error("error ",error);
        });
      }
  });
 
}

nuevoControl(){
  this.router.navigate(['crear'],{relativeTo:this.route});
}
dayOfWeek(day){
  let diaSemana="";
 switch(day) {
     case 0:
     diaSemana="Domingo";
     break;
     case 1:
     diaSemana="Lunes";
     break;
     case 2:
     diaSemana="Martes";
     break;
     case 3:
     diaSemana="Miercoles";
     break;
     case 4:
     diaSemana="Jueves";
     break;
     case 5:
     diaSemana="Viernes";
     break;
     case 6:
     diaSemana="Sabado";
     break;
     default:
    
 }
 return diaSemana;
}


fechaSeleccionada(fecha){
  let today = new Date(fecha);
 
  let day = today.getDay();

  
  let myfecha=this.dayOfWeek(day);
  return myfecha;
 }
 
 

info(control){
  
  this.display=true;
  this.expression=true;
  this.controlDataUpdate=control;
  //console.log(this.controlDataUpdate.id);
  this.createControlForm.patchValue({
    'id':this.controlDataUpdate.id,
    'fecha':this.controlDataUpdate.fecha,
    'mes':this.controlDataUpdate.mes,
    'zona1':this.controlDataUpdate.zona1,
    'zona2':this.controlDataUpdate.zona2,
    'zona3':this.controlDataUpdate.zona3,
    'zona4':this.controlDataUpdate.zona4,
    'zona5':this.controlDataUpdate.zona5,
    'zona6':this.controlDataUpdate.zona6,
    'zona7':this.controlDataUpdate.zona7,
    'zona8':this.controlDataUpdate.zona8,
    'zona9':this.controlDataUpdate.zona9,
    'fechaoperario':this.controlDataUpdate.fechaoperario,
    'nombreoperario':this.controlDataUpdate.nombreoperario,
    'revisado_fecha':this.controlDataUpdate.revisado_fecha,
    'revisado_nombre':this.controlDataUpdate.revisado_nombre,
   
  });


}



ngDoCheck(){
  //this.cambiarMes();
 
}
iniciarUpdate(){
if(!this.controlDataUpdate){
  this.createControlForm=new FormGroup({
    id:new FormControl(''),
    fecha:new FormControl(this.fecha(),Validators.required),
    mes:new FormControl({value: this.myMonth, disabled: true}),
    zona1:new FormControl(true),
    zona2:new FormControl(true),
    zona3:new FormControl(true),
    zona4:new FormControl(true),
    zona5:new FormControl(true),
    zona6:new FormControl(true),
    zona7:new FormControl(true),
    zona8:new FormControl(true),
    zona9:new FormControl(true),
    fechaoperario:new FormControl('',Validators.required),
    nombreoperario:new FormControl('',Validators.required),
    revisado_fecha:new FormControl('',Validators.required),
    revisado_nombre:new FormControl('',Validators.required),
  });
}else{
  this.createControlForm=new FormGroup({
    id:new FormControl(''),
    fecha:new FormControl(this.fecha(),Validators.required),
    mes:new FormControl({value: this.myMonth, disabled: true}),
    zona1:new FormControl(true),
    zona2:new FormControl(true),
    zona3:new FormControl(true),
    zona4:new FormControl(true),
    zona5:new FormControl(true),
    zona6:new FormControl(true),
    zona7:new FormControl(true),
    zona8:new FormControl(true),
    zona9:new FormControl(true),
    fechaoperario:new FormControl('',Validators.required),
    nombreoperario:new FormControl('',Validators.required),
    revisado_fecha:new FormControl('',Validators.required),
    revisado_nombre:new FormControl('',Validators.required),
  });
}
  
}
onSubmit(){
  console.log(this.createControlForm.value);
  
  this.controlService.updateControl(this.createControlForm.value).subscribe(resp=>{
    console.log(resp);
    this.messageService.add({severity:'success', summary:'Registro', detail:'Registro guardado correctamente'});
    this.display=false;
    this.iniciar();
  },error=>{
    this.messageService.add({severity:'error', summary:'Resgistro', detail:'Error en el registro '+error+''});
    console.log(error);

  });
}
cambiarMes() {
  let fecha=this.createControlForm.controls.fecha.value;
  let posiciones=fecha.split("-");
  this.myMonth=this.seleccionarMes(parseInt(posiciones[1]));
  this.createControlForm.patchValue({
    'mes':this.myMonth,
  })

}
seleccionarMes(mes){
  let month="";
    switch(mes) {
    case 1:
    month="Enero";
    break;
    case 2:
    month="Febrero";
    break;
    case 3:
    month="Marzo";
    break;
    case 4:
    month="Abril";
    break;
    case 5:
    month="Mayo";
    break;
    case 6:
    month="Junio";
    case 7:
    month="Julio";
    break;
    case 8:
    month="Agosto";
    break;
    case 9:
    month="Septiembre";
    break;
    case 10:
    month="Octubre";
    break;
    case 11:
    month="Noviembre";
    break;
    case 12:
    month="Diciembre";
    break;
    default:
   
}
return month;
}
fecha(){
  let today = new Date();
  let dd = today.getDate();
  var mm = today.getMonth()+1; //January is 0!
  var yyyy = today.getFullYear();
  var MM = "";
  var DD = "";
  if(mm<10){
    MM=(0).toString()+mm.toString();
  }else{
    MM=mm.toString();
  }

  if(dd<10){
    DD=(0).toString()+mm.toString();
  }else{
    DD=dd.toString();
  }
 
  let myfecha = mm + '/' + dd + '/' + yyyy;
  myfecha=yyyy+'-'+MM + '-' + DD ;
  //console.log(myfecha);
  return myfecha;
 }

/*  recuperarPosicion() {

  try {
    if ( localStorage.getItem('guardar_posicion') !== null || localStorage.getItem('guardar_posicion') !== undefined || (localStorage.getItem('guardar_posicion').localeCompare('') !== 0) ) {
      this.first = Number(localStorage.getItem('guardar_posicion')) ;
      localStorage.setItem('guardar_posicion', '');
     } else {
      this.first = 0;
     }
  } catch (error) {
    this.first = 0;
  }
  
} */

 redirect(id, index) {
  localStorage.setItem('guardar_posicion', index.toString());
  this.router.navigate(['edit',id],{relativeTo:this.route});
 }
 cerrar(){
   this.display=false;
  
  this.expression=false;
 }
 closeWindow(event){
    this.cerrar();
 }

 filtrarFecha(event,dt,col){
    
     
  if( event==null || event=="" || event == undefined || event== {} ) {
   dt.filter(null,'fecha', col.filterMatchMode);
  }else{
   let myfecha=new Date(event);
   let mes=(myfecha.getMonth()+1);
   let mesCorregido="";
   let dia=myfecha.getDate();
   let diaCorregido="";
   if(mes<10){
     mesCorregido="0"+mes;
   }else{
     mesCorregido=""+mes;
   }
   if(dia<10){
     diaCorregido="0"+dia;
   }else{
     diaCorregido=""+dia;
   }

   let segmentarFEcha=diaCorregido+"/"+(mesCorregido)+"/"+myfecha.getFullYear();
   
   dt.filter(segmentarFEcha,'fecha', col.filterMatchMode);
  }
  this.cambios(dt);
}

public mydt:any;
closeWindowMultpile(event){
  this.consultar();
}

cambios(dt){

  this.mydt = dt;
 
}
consultar(event = null) {
  if ( event != null ) {
    if (event.filteredValue) {
      this.imprimirMultipleService.showProducts(event.filteredValue);
    if (this.displayMultiple) {
      this.displayMultiple = false;
    } else {
      this.displayMultiple=true;
    }
    if(this.mydt==null || this.mydt==undefined ||this.mydt==[]||this.mydt.length==0){
     
      //console.log(this.tiritas);
      
    }else if(this.mydt.filteredValue==null|| this.mydt==undefined){
      //console.log(this.tiritas);
    }else{
      //console.log(this.mydt.filteredValue);   
    }
    } else {
      this.mydt = event;
      this.imprimirMultipleService.showProducts(event.value);
    if (this.displayMultiple) {
      this.displayMultiple = false;
    } else {
      this.displayMultiple=true;
    }
    if(this.mydt==null || this.mydt==undefined ||this.mydt==[]||this.mydt.length==0){
     
      //console.log(this.tiritas);
      
    }else if(this.mydt.filteredValue==null|| this.mydt==undefined){
      //console.log(this.tiritas);
    }else{
      //console.log(this.mydt.filteredValue);   
    }
    }
    
    
    
    
  } else {
    this.imprimirMultipleService.showProducts(this.listadoProductos());
  if (this.displayMultiple) {
    this.displayMultiple = false;
  } else {
    this.displayMultiple=true;
  }
  if(this.mydt==null || this.mydt==undefined ||this.mydt==[]||this.mydt.length==0){
   
    //console.log(this.tiritas);
    
  }else if(this.mydt.filteredValue==null|| this.mydt==undefined){
    //console.log(this.tiritas);
  }else{
    //console.log(this.mydt.filteredValue);   
  }
  }



console.log("event ", event );

}

listadoProductos() {

  if( this.mydt == null || this.mydt == undefined ||this.mydt == [] || this.mydt.length==0){
    return this.control;
    
    
  }else if(this.mydt.filteredValue == null || this.mydt == undefined ){
    
    return this.control;
  }else{
    return this.mydt.filteredValue;
    //console.log(this.mydt.filteredValue);   
  }
}

duplicate(control){

  //console.log(control);
  
  control.fecha=this.arreglarfecha(control.fecha);
  //console.log(zumo.fecha);
this.controlService.createControl(control).toPromise().then(data=>{
  this.messageService.add({severity:'success', summary:'Registro Control', detail:'Registro Control Duplicado'});
  this.iniciar();
}).catch(error=>{
  this.messageService.add({severity:'error', summary:'Registro Control', detail:'Error en registro de Control'});
  console.log("error",error)
})

  
}

arreglarfecha(fecha){
  let arregloFecha=fecha.split("/");
  let today = new Date(arregloFecha[2],arregloFecha[1],arregloFecha[0]);
   
  let dd = today.getDate();
  let DD="";
  var mm = today.getMonth(); //January is 0!
  let MM="";
  var yyyy = today.getFullYear();
  if(mm<10){
    MM="0"+mm;
  }else{
    MM=""+mm;
  }
  if(dd<10){
      DD="0"+dd;
  }else{
    DD=""+dd;
  }
 
  let myfecha = MM + '/' + DD + '/' + yyyy;
  myfecha=yyyy+'-'+MM + '-' + DD ;
 // console.log(myfecha);
  return myfecha;
 }

 
/**
 *
 *
 * @param {string} columna
 * @param {string} valor
 * @returns {boolean}
 * @memberof ControlComponent
 */
comprobarFilaValor( columna: string, valor: string ):boolean { 
 this.arrrayBooleanos = ['zona1','zona2','zona3','zona4','zona5','zona6','zona7','zona8','zona9'];

  if ( this.arrrayBooleanos.includes( columna ) ) {
  
    return true;
  } 

  return false;

}

checkRole() {
  try {
    if ( localStorage.getItem('role').localeCompare('ROLE_ADMIN') == 0 ) {
      return true;
    } else {
      return false;
    }
  } catch (error) {
    return false;
  }
   
}
checkRevisionTirita() {
  if (localStorage.getItem('role').localeCompare('ROLE_ADMIN') == 0) {
    return true;
  }
  let readonly = '';
  try {
    readonly = localStorage.getItem('readonly');
  } catch (error) {
    readonly = '';
  }
  if ( readonly.localeCompare('1') == 0 ){
    return false;
  } else {
    return true;
  }
}
checkRevisionButtonsCancel( value) {
  try {
    if ( localStorage.getItem('readonly').localeCompare('1') == 0 ){
      return false;
    }
  } catch (error) {
    
  }
 

  if ( value == null || value == undefined ) {
    return false;
  } 
  if ( value.length > 1 ) {
    return true;
  } 
}
checkRevisionButtons( value) {
  try {
    if ( localStorage.getItem('readonly').localeCompare('1') == 0 ){
      return false;
    }
  } catch (error) {
    
  }
 
  if ( localStorage.getItem('role').localeCompare('ROLE_ADMIN') == 0 ){
    return true;
  }
  if ( value == null || value == undefined ) {
    return true;
  } 
  if ( value.length > 1 ) {
    return false;
  } else {
    return true;
  }
}
checkRevision(value) {
  try {
    if ( value == null || value == undefined ) {
      return false;
    } else {
      if ( (value as string).length > 1 ) { 
        return true;
      } else {
        return false;
      }
     
    }
  } catch (error) {
    return false;
  }
   
}

changeValueRevision( data: any ) {

  //console.log('data.revision',data.revision);
    
  try {
   
    if (data.revision == null || data.revision == undefined || data.revision.length == 0 ) {
      //console.log(data, this.database);
      let revision = JSON.parse(localStorage.getItem('calidad_user_tag_1'));
      //console.log(revision);
      
      let firma = {
        revision: revision.name,
        id: data.id,
        database: 'plasticos' 
      }
      this.FirmaRevisionService.updateFirma( firma).toPromise()
      .then( resp => {
        //console.log( 'firma', resp );
        this.iniciar();
      }).catch ( error => {
        console.log(' error', error );
        
      });
    } else {
      let firma = {
        revision: '',
        id: data.id,
        database: 'plasticos' 
      }
      this.FirmaRevisionService.updateFirma( firma).toPromise()
      .then( resp => {
        //console.log( 'firma', resp );
        this.iniciar();
      }).catch ( error => {
        console.log(' error', error );
        
      });
    }
  } catch (error) {
    let firma = {
      revision: '',
      id: data.id,
      database: this.database 
    }
    this.FirmaRevisionService.updateFirma( firma).toPromise()
    .then( resp => {
      //console.log( 'firma', resp );
      this.iniciar();
    }).catch ( error => {
      console.log(' error', error );
      
    });
  }
  this.iniciar();
  
}

checkRevisionandRole(value) {
  try {
    if ( value == null || value == undefined ) {
      return false;
    } else {
      if ( (value as string).length > 1 ) {
        if( localStorage.getItem('role') == null) { 
          return false;
        } 
        if( localStorage.getItem('role').localeCompare('ROLE_ADMIN') == 0 ) { 
          return false;
        } 
        return true;
      } else {
        return false;
      }
     
    }
  } catch (error) {
    return false;
  }
   
}


}
